import { useRef } from "react";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { AxiosResponse } from "axios";
import { checkAuth, getLogoutPath, validateMenuPathForEmployee } from "../../utils/common";
import { ValidateReq,ValidateRes } from "../../utils/types";
const useMenuPathValidation = (actualPath: string, excludedPaths: string[] = []) => {
  const navigate = useNavigate();
  // the page the user is on now: an answer for a page already left is ignored, otherwise a quick move
  // (a list opening its first record) sent the user to /404
  const current = useRef(actualPath);
  current.current = actualPath;

  const { mutate: validateMenuPath } = useMutation<
    AxiosResponse<ValidateRes>,
    Error,
    ValidateReq
  >({
    mutationKey: ["validateMenuPath"],
    mutationFn: validateMenuPathForEmployee, // Assuming this function exists
    onSuccess: (resp: any, vars: ValidateReq) => {
      if (vars.menu_path !== current.current) return true;
      if (resp.status === true) {
        if (resp.result[0].MENU_PROG_PATH === vars.menu_path) {
          return true;
        }
      }
      navigate("/404");
      return false;
    },
    onError: (_e: Error, vars: ValidateReq) => {
      // no login token (session ended or logged out in another tab): the API
      // answers 401, which is not a rights problem, so go to the login page
      if (!checkAuth()) {
        window.location.href = getLogoutPath();
        return false;
      }
      if (vars.menu_path !== current.current) return true;
      navigate("/404");
      return false;
    },
  });

  const executeValidation = (menu_path: string,menu_right_code:string) => {
    if (excludedPaths.includes(menu_path)) {
      return; // Skip validation for excluded paths
    }
    validateMenuPath({ menu_path,menu_right_code });
  };

  return executeValidation;
};

export default useMenuPathValidation;
